import React from 'react'
import HomeAppBar from './Navigation/HomeAppBar';

const Header = () => {
    return (
        <HomeAppBar />
    )
}
export default Header